<template>
  <div id="main" class="all_colors" data-scroll-offset="85">
    <div id="after_full_slider_1" class="main_color av_default_container_wrap container_wrap sidebar_right">
      <div v-if="educationsLoaded" class="container">
        <div v-if="allEducations.length == 0 || allEducations.length == undefined" style="margin-top:30px;">
        <h2>Trenutno nema otvorenih javnih poziva :(</h2>
        </div>
        <div v-if="allEducations.length>0" style="margin-top: 10px!important;" class="av-special-heading av-special-heading-h4 meta-heading blockquote modern-quote avia-builder-el-5 el_after_av_heading el_before_av_contact">
          <div v-for="(item, index) in allEducations" v-bind:key = "index" class="av-magazine-content-wrap">
            <header class="entry-content-header">
              <span class="av-magazine-text-sep text-sep-date">Datum održavanja: </span>
              <time class="av-magazine-time updated" itemprop="datePublished" :datetime="item.date_of_occurrence">{{ item.date_of_occurrence }}</time>
              <h3 class="av-magazine-title entry-title" itemprop="headline">
                <router-link :to="{ path: '/' + item.fauna_id}">
                  {{ item.title }}
                </router-link>
              </h3>
            </header>
            <br />
          </div>
        </div>
      </div>
    </div>   
  </div>
</template>

<script>

import {
  getEducations
} from "../models/EducationsModel";

export default {
  name: "Home",
  props: {
    msg: String,
  },
  data() {
    return {
      education: {
        title: "",
        date_of_occurrence: "",
        application_deadline: "",
      },
      allEducations: [],
      educationsLoaded: false,
    };
  },
  beforeMount() {
   getEducations()
    .then(resp => {
      this.allEducations = resp || [];
      this.educationsLoaded = true;
    })
    .catch(err => {
      console.error("Error getting educations", err);
      this.allEducations = [];
      this.educationsLoaded = true;
    });
  },
  methods: {
    
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#main {
  height: 100vh;
}

</style>
